<template>
  <button type="button" class="btn btn-outline-primary" @click="showModal()">Auswählen</button>

  <!-- Select Signatur Modal -->
  <div
    class="modal fade"
    :id="'selectSignaturModal-' + index"
    tabindex="-1"
    aria-labelledby="selectSignaturModal"
    aria-hidden="true"
    ref="selectSignaturModalRef"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2">
          <strong class="modal-titel my-auto">Signatur auswählen</strong>

          <button type="button" class="btn-close btn-sm text-white" @click="closeModal()"></button>
        </div>

        <div class="modal-body modal-body-min-height" id="selectSignaturModalBody">
          <div class="row mb-3">
            <div class="col-4 offset-4">
              <div class="input-group input-group-sm my-auto">
                <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
                <span class="input-group-text">
                  <font-awesome-icon icon="magnifying-glass" class="p-1" />
                </span>
              </div>
            </div>
          </div>

          <div class="row mx-1 mb-2 bg-white shadow-sm">
            <div class="col-4 py-2 table-col">
              <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <strong>Unterschrift</strong>

                <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'unterschriftasc'" class="text-secondary table-sort-icon" />
                <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'unterschriftdesc'" class="text-secondary table-sort-icon" />

                <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                  <li class="dropdown-item select-sort" @click="sortBy('unterschriftasc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'unterschriftasc'" />
                      </div>
                      <div class="col">A - Z</div>
                    </div>
                  </li>
                  <li class="dropdown-item select-sort" @click="sortBy('unterschriftdesc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'unterschriftdesc'" />
                      </div>
                      <div class="col">Z - A</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-3 py-2 table-col">
              <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <strong>Zeichnung</strong>

                <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'zeichnungasc'" class="text-secondary table-sort-icon" />
                <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'zeichnungdesc'" class="text-secondary table-sort-icon" />

                <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                  <li class="dropdown-item select-sort" @click="sortBy('zeichnungasc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'zeichnungasc'" />
                      </div>
                      <div class="col">A - Z</div>
                    </div>
                  </li>
                  <li class="dropdown-item select-sort" @click="sortBy('zeichnungdesc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'zeichnungdesc'" />
                      </div>
                      <div class="col">Z - A</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-3 py-2 table-col">
              <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <strong>Funktion</strong>

                <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'funktionsasc'" class="text-secondary table-sort-icon" />
                <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'funktionsdesc'" class="text-secondary table-sort-icon" />

                <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                  <li class="dropdown-item select-sort" @click="sortBy('funktionsasc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'funktionsasc'" />
                      </div>
                      <div class="col">A - Z</div>
                    </div>
                  </li>
                  <li class="dropdown-item select-sort" @click="sortBy('funktionsdesc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'funktionsdesc'" />
                      </div>
                      <div class="col">Z - A</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-2 py-2 table-col">
              <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <strong>Funktion EN</strong>

                <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'funktionENasc'" class="text-secondary table-sort-icon" />
                <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'funktionENdesc'" class="text-secondary table-sort-icon" />

                <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                  <li class="dropdown-item select-sort" @click="sortBy('funktionENasc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'funktionENasc'" />
                      </div>
                      <div class="col">A - Z</div>
                    </div>
                  </li>
                  <li class="dropdown-item select-sort" @click="sortBy('funktionENdesc')">
                    <div class="row">
                      <div class="col-2">
                        <font-awesome-icon icon="check" v-show="sortByValue == 'funktionENdesc'" />
                      </div>
                      <div class="col">Z - A</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="sortedSignatur.length == 0" class="alert alert-info mb-3">Es wurden keine Signaturen gefunden.</div>

          <div
            v-for="signatur in sortedSignatur"
            :key="signatur.id"
            class="row mx-1 mb-2 py-2 bg-white shadow-sm select-partner-row"
            @click="selectSignatur(signatur.id)"
          >
            <div class="col-3">{{ signatur.unterschrift }}</div>
            <div class="col-3">{{ signatur.zeichnung }}</div>
            <div class="col-3">{{ signatur.funktion }}</div>
            <div class="col-3">{{ signatur.funktionEN }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref, computed } from 'vue';
  import { Modal } from 'bootstrap';
  import { useStore } from '@/store';

  import { Signatur } from '@/models/VertragspartnerModels';
  //#endregion

  const { index } = defineProps({
    index: {
      type: Number as PropType<number>,
      default: 0,
    },
  });

  const emit = defineEmits(['select-signatur']);

  const store = useStore();

  const searchString = ref('');
  const sortByValue = ref('unterschriftasc');
  function sortBy(param: string) {
    sortByValue.value = param;
  }

  const signaturen = computed(() => store.getters.signaturen);
  const sortedSignatur = computed(() => {
    return signaturen.value
      .filter((v: Signatur) => {
        return (
          v.unterschrift.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.zeichnung.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.funktion.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.funktionEN.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: Signatur, b: Signatur) => {
        if (sortByValue.value == 'unterschriftasc' || sortByValue.value == 'unterschriftdesc') {
          var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
          if (sortByValue.value == 'unterschriftdesc') {
            unterschriftComparison = -1 * unterschriftComparison;
          }

          if (unterschriftComparison == 0) {
            var zeichnungComparison = a.zeichnung.trim().toLowerCase().localeCompare(b.zeichnung.trim().toLowerCase());
            return zeichnungComparison;
          }

          return unterschriftComparison;
        } else if (sortByValue.value == 'zeichnungasc' || sortByValue.value == 'zeichnungdesc') {
          var zeichnungComparison = a.zeichnung.trim().toLowerCase().localeCompare(b.zeichnung.trim().toLowerCase());

          if (sortByValue.value == 'zeichnungdesc') {
            zeichnungComparison = -1 * zeichnungComparison;
          }

          if (zeichnungComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
            return unterschriftComparison;
          }

          return zeichnungComparison;
        } else if (sortByValue.value == 'funktionasc' || sortByValue.value == 'funktiondesc') {
          var funktionComparison = a.funktion.trim().toLowerCase().localeCompare(b.funktion.trim().toLowerCase());

          if (sortByValue.value == 'funktiondesc') {
            funktionComparison = -1 * funktionComparison;
          }

          if (funktionComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());

            return unterschriftComparison;
          }

          return funktionComparison;
        } else if (sortByValue.value == 'funktionENasc' || sortByValue.value == 'funktionENdesc') {
          var funktionENComparison = a.funktionEN.trim().toLowerCase().localeCompare(b.funktionEN.trim().toLowerCase());
          if (sortByValue.value == 'funktionENdesc') {
            funktionENComparison = -1 * funktionENComparison;
          }

          if (funktionENComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());

            return unterschriftComparison;
          }

          return funktionENComparison;
        }

        return 0;
      });
  });

  function selectSignatur(signaturid: number) {
    emit('select-signatur', index, signaturid);
    closeModal();
  }

  //#region Modal
  const selectSignaturModalRef = ref();

  function closeModal() {
    Modal.getInstance(selectSignaturModalRef.value)?.hide();
  }

  function showModal() {
    if (selectSignaturModalRef.value) {
      new Modal(selectSignaturModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }

  .select-partner-row:hover {
    background: #fff4af !important;
    cursor: pointer;
  }
</style>
